import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './RadioButtonGroup.module.css';
import { RadioItem } from './components/RadioItem';
import Card from '../Card';

const bindClasses = classNameBind.bind(styles);

const RadioButtonGroup = ({
  name,
  options,
  disabled = false,
  value = '',
  onChange = () => {},
  onBlur = () => {},
  dataId = 'RadioButtonGroup',
}) => {
  // eslint-disable-next-line eqeqeq
  const chosen = options.find(item => value == item.value);

  return (
    <div data-ppuc-id={dataId}>
      <div className={bindClasses('items')}>
        {options.map(item => (
          <RadioItem
            key={item.id}
            id={item.id}
            name={name}
            value={item.value}
            // eslint-disable-next-line eqeqeq
            selected={value == item.value}
            disabled={disabled || item.disabled}
            onClick={onChange}
            onBlur={onBlur}
            dataId={dataId}
            label={item.label}
            labelTitle={item.labelTitle}
            caption={item.caption}
          />
        ))}
      </div>
      {(chosen && chosen.children) && (
        <div
          className={bindClasses('additional-content')}
          data-ppuc-id={`${dataId}.additional-content`}
        >
          <Card>
            <Card.Section subdued condensed>
              {chosen.children}
            </Card.Section>
          </Card>
        </div>
      )}
    </div>
  );
};

export { RadioButtonGroup };
